export const firebaseConfig = {
    apiKey: "AIzaSyDBYEBTL28k8KsZnL-V3BMG84e8_vvi1yY",
    authDomain: "or-rn-781f7.firebaseapp.com",
    projectId: "or-rn-781f7",
    storageBucket: "or-rn-781f7.appspot.com",
    messagingSenderId: "1005781726165",
    appId: "1:1005781726165:web:222618cd7322e2f415c35c",
    measurementId: "G-LGQN07VK1E"
};
